<template lang="pug">
  .b-datetime-picker(:class="{ opened }")
    ._overlay(v-if="opened" @click="close")
    ._datetime-selector(v-if="opened")
      ._calendar(:id="fieldId(false)")
      ._btns
        Btn(sm transparent grey @click="drop")
          Icon(name="mobile-close" style="height: 15px; width: auto" pointer)
        Btn(sm transparent @click="commit")
          Icon(name="complete" style="height: 10px; width: auto"  pointer)
    ._label(v-if="labelOuter && label") {{ label }}
    input._input(
      readonly
      :value="formatDate(value)"
      :placeholder="labelOuter ? '' : label"
      :class="{ hidden }"
      @focus="open(false)"
      ref="field"
    )
</template>

<script>
import AirDatepicker from 'air-datepicker';
import ru from 'air-datepicker/locale/ru';
import 'air-datepicker/air-datepicker.css';
import utils from '@/utils/common';

export default {
  name: 'BaseDatepicker',
  props: {
    value: [String, Date],
    type: String,
    label: String,
    hidden: Boolean,
    labelOuter: Boolean,
  },
  data() {
    return {
      opened: false,
      selectedValue: null,
      externalOpen: false,
    };
  },
  computed: {
    withTime() { return this.type === 'datetime'; },
    displayValue() { return this.selectedValue ?? this.value; },
  },
  datepickerInstance: null,
  emitTimeoutId: null,
  methods: {
    fieldId(withHashSign = true) {
      // eslint-disable-next-line no-underscore-dangle
      return `${withHashSign ? '#' : ''}datepicker${this._uid}`;
    },
    drop() {
      this.$emit('input', null);
      this.$emit('change', null);
      this.close();
    },
    commit() {
      let datetime = new Date(this.$options.instance.lastSelectedDate);

      if (!+datetime) {
        this.drop();
        return;
      }

      if (!this.withTime) {
        datetime = new Date(Date.UTC(datetime.getFullYear(), datetime.getMonth(), datetime.getDate()));
      }

      this.$emit('input', datetime);
      this.$emit('change', datetime);
      this.close();
    },
    open(externalOpen = true) {
      this.externalOpen = externalOpen;

      if (this.opened) {
        return;
      }

      this.opened = true;

      this.$nextTick(() => {
        this.$options.instance = new AirDatepicker(this.fieldId(), {
          inline: true,
          locale: ru,
          timepicker: this.withTime,
          minutesStep: 5,
          selectedDates: this.value ? [this.value] : [new Date((new Date()).setHours(18, 0, 0, 0))],
          // buttons: ['clear'],
          // onSelect: this.datetimeSelected,
          dateFormat: this.formatDate,
        });
      });
    },
    formatDate(date) { return date ? utils.convertDateToString(new Date(date), 'short', this.withTime) : ''; },
    close() {
      this.$options.instance.destroy();
      this.$options.instance = null;
      this.selectedValue = null;
      this.opened = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.datetime-picker {
  position: relative;

  &__overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }

  &__calendar ::v-deep .air-datepicker {
    border: none;
  }

  &__btns {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__datetime-selector {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    z-index: 10000;
    background: #fff;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
  }

  &__label {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #92A0B0;
    margin-bottom: 8px;
  }

  &__input {
    cursor: pointer;
    width: 100%;
    font-size: 13px;
    height: 39px;
    padding: 0 16px;
    border-radius: 6px;
    color: var(--color-dark-gray);
    outline: none;
    font-weight: 500;
    box-sizing: border-box;

    background-color: var(--color-super-light);
    background-image: url(../assets/img/svg/calendar-alt.svg);
    background-repeat: no-repeat;
    background-position: top 6.5px right 16px;
    background-size: 24px;

    &::placeholder {
      opacity: 1;
      font-weight: 500;
      color: var(--color-middle-gray);
    }

    &.hidden {
      width: 0;
      height: 0;
      opacity: 0;
    }
  }

  @media (max-width: 1000px) {
    &__overlay {
      background: #000;
      opacity: .5;
    }

    &__datetime-selector {
      position: fixed;
      left: 50vw;
      top: 50vh;
      transform: translate(-50%, -50%);
    }
  }
}

//.date-picker::v-deep {
//  .vdp-datepicker__calendar {
//    z-index: 1000;
//    border: none;
//    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 16%);
//    padding: 10px;
//    border-radius: 8px
//  }
//
//  input {
//    cursor: pointer;
//    width: 100%;
//    font-size: 13px;
//    height: 39px;
//    padding: 0 16px;
//    border-radius: 6px;
//    color: var(--color-dark-gray);
//    outline: none;
//    font-weight: 500;
//
//    background-color: var(--color-super-light);
//    background-image: url(../assets/img/svg/calendar-alt.svg);
//    background-repeat: no-repeat;
//    background-position: top 6.5px right 16px;
//    background-size: 24px;
//
//    &::placeholder {
//      opacity: 1;
//      font-weight: 500;
//      color: var(--color-middle-gray);
//    }
//  }
//
//  &.hidden input {
//    width: 0;
//    height: 0;
//    opacity: 0;
//    //display: none;
//    visibility: hidden;
//  }
//}
//
//@media (max-width: 768px) {
//  .datepicker-calendar {
//    position: fixed !important;
//    top: 50%;
//    left: 50%;
//    margin-left: -150px;
//    margin-top: -150px;
//  }
//}
</style>
